class FavoriteForm {
    public cId: number;
    public UserContactId: string;
    public FormType: number;
    public FormId: string;
}

export { FavoriteForm };
